__turbopack_context__.v({
  "breadcrumbWrap": "ContactUs-module__nUpk0q__breadcrumbWrap",
  "errorText": "ContactUs-module__nUpk0q__errorText",
  "field": "ContactUs-module__nUpk0q__field",
  "fieldGrid": "ContactUs-module__nUpk0q__fieldGrid",
  "fieldLabel": "ContactUs-module__nUpk0q__fieldLabel",
  "form": "ContactUs-module__nUpk0q__form",
  "formCard": "ContactUs-module__nUpk0q__formCard",
  "formSection": "ContactUs-module__nUpk0q__formSection",
  "formTitle": "ContactUs-module__nUpk0q__formTitle",
  "formWrap": "ContactUs-module__nUpk0q__formWrap",
  "header": "ContactUs-module__nUpk0q__header",
  "headingBlock": "ContactUs-module__nUpk0q__headingBlock",
  "hiddenFileInput": "ContactUs-module__nUpk0q__hiddenFileInput",
  "input": "ContactUs-module__nUpk0q__input",
  "inputError": "ContactUs-module__nUpk0q__inputError",
  "mapFrame": "ContactUs-module__nUpk0q__mapFrame",
  "mapWrap": "ContactUs-module__nUpk0q__mapWrap",
  "page": "ContactUs-module__nUpk0q__page",
  "phoneField": "ContactUs-module__nUpk0q__phoneField",
  "reachCard": "ContactUs-module__nUpk0q__reachCard",
  "reachCardDetail": "ContactUs-module__nUpk0q__reachCardDetail",
  "reachDetail": "ContactUs-module__nUpk0q__reachDetail",
  "reachGrid": "ContactUs-module__nUpk0q__reachGrid",
  "reachIconWrap": "ContactUs-module__nUpk0q__reachIconWrap",
  "reachLink": "ContactUs-module__nUpk0q__reachLink",
  "reachTitle": "ContactUs-module__nUpk0q__reachTitle",
  "select": "ContactUs-module__nUpk0q__select",
  "submitBtn": "ContactUs-module__nUpk0q__submitBtn",
  "textarea": "ContactUs-module__nUpk0q__textarea",
  "uploadBox": "ContactUs-module__nUpk0q__uploadBox",
  "uploadBoxActive": "ContactUs-module__nUpk0q__uploadBoxActive",
  "uploadHint": "ContactUs-module__nUpk0q__uploadHint",
  "uploadText": "ContactUs-module__nUpk0q__uploadText",
});
